import { Collection } from "../../../../../models";

export const tempDTOForGanttGroup = (collection: Collection): Collection => {
    if(collection.defaultView !== 'gantt') return collection

    collection.newGroupTasksTitle = 'Unassigned tasks group'
    return collection

    // const views = collection.collectionViews ?? []
    
    // const kanbanView = views.find(x => x.collectionViewType === 'Kanban')
    // const ganttView = views.find(x => x.collectionViewType === 'Gantt')
    // if(!kanbanView) return collection
    // if(!ganttView) return collection

    // ganttView.itemLists = kanbanView.itemLists.map(x => {
    //     return {...x, title: `${x.title} temp`}
    // })

    // const updatedViews = views.map(x => x.collectionViewType === 'Kanban' ? kanbanView : x.collectionViewType === 'Gantt' ? ganttView : x)
    
    // return {
    //     ...collection,
    //     collectionViews: updatedViews
    // }
}